import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';

type DetailPageLayoutProps = {
  headerComp: ReactNode;
  firstColumnComp: ReactNode;
  middleColumnComp: ReactNode;
  lastColumnComp: ReactNode;
};
export const DetailPageLayout = ({
  headerComp,
  firstColumnComp,
  middleColumnComp,
  lastColumnComp,
}: DetailPageLayoutProps) => {
  return (
    <Grid container spacing={{ xs: 2, md: 3 }}>
      {/* Header */}
      <Grid size={{ xs: 12 }}>{headerComp}</Grid>

      {/* First column */}
      <Grid
        container
        wrap={'nowrap'}
        direction="column"
        rowSpacing={{ xs: 2, md: 3 }}
        size={{ xs: 12, md: 4 }}
      >
        {firstColumnComp}
      </Grid>

      {/* Middle column */}
      <Grid
        container
        wrap={'nowrap'}
        direction="column"
        rowSpacing={{ xs: 2, md: 3 }}
        size={{ xs: 12, md: 4 }}
      >
        {middleColumnComp}
      </Grid>

      {/* Last column  */}
      <LastGrid
        container
        wrap={'nowrap'}
        size={{ xs: 12, md: 4 }}
        direction="column"
        rowSpacing={{ xs: 2, md: 3 }}
      >
        {lastColumnComp}
      </LastGrid>
    </Grid>
  );
};

const LastGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(5),
  },
}));
